export const FilterGroup = {
  Status: 'status',
  Tags: 'tags',
} as const;
export type FilterGroup = (typeof FilterGroup)[keyof typeof FilterGroup];

export const NoteStatus = {
  Completed: 'completed',
  Incompleted: 'incompleted',
} as const;
export type NoteStatus = (typeof NoteStatus)[keyof typeof NoteStatus];

export const NotesPopoverType = {
  Filter: 'filter',
  View: 'view',
} as const;
export type NotesPopoverType = (typeof NotesPopoverType)[keyof typeof NotesPopoverType];

export const NotesViewType = {
  Date: 'date',
  List: 'list',
} as const;
export type NotesViewType = (typeof NotesViewType)[keyof typeof NotesViewType];

export const DateGroupByType = {
  CreationDate: 'creation-date',
} as const;
export type DateGroupByType = (typeof DateGroupByType)[keyof typeof DateGroupByType];

export const ListGroupByType = {
  Tags: 'tags',
  Status: 'status',
} as const;
export type ListGroupByType = (typeof ListGroupByType)[keyof typeof ListGroupByType];

/* Component displayed in sidebar */
export const SidebarStep = {
  NotesList: 'list',
  Note: 'note',
} as const;
export type SidebarStep = (typeof SidebarStep)[keyof typeof SidebarStep];

/**
 * Variant of adding new note
 *
 * - `Tag` - Adding note attached to tag
 * - `Temporary` - Adding any other note (adding note by selecting its position in 3D space)
 */
export const AddNoteMode = {
  Temporary: 'temporary',
  Tag: 'tag',
} as const;
export type AddNoteMode = (typeof AddNoteMode)[keyof typeof AddNoteMode];

/**
 * Enum that backend understands to either send SAP report or just create a message
 */
export const NoteFormat = {
  General: 'message',
  Bazan: 'SAP',
} as const;
export type NoteFormat = (typeof NoteFormat)[keyof typeof NoteFormat];

/**
 * Represents the type of integration used in the notes system.
 * Used by frontend to toggle UI elements based on active integration.
 */
export const NoteIntegration = {
  None: 'none',
  Bazan: 'bazan',
  ICL: 'icl',
} as const;
export type NoteIntegration = (typeof NoteIntegration)[keyof typeof NoteIntegration];

export const NotesSortingType = {
  CreationDate: 'create-date-desc',
  DueDate: 'due-date-desc',
} as const;
export type NotesSortingType = (typeof NotesSortingType)[keyof typeof NotesSortingType];

export const NoteType = {
  PreventiveMaintenance: 'preventive-maintenance',
  Fault: 'fault',
  General: 'general',
} as const;
export type NoteType = (typeof NoteType)[keyof typeof NoteType];

export const NotePriority = {
  Highest: 'highest',
  High: 'high',
  Medium: 'medium',
  Low: 'low',
  Lower: 'lower',
  Lowest: 'lowest',
} as const;
export type NotePriority = (typeof NotePriority)[keyof typeof NotePriority];
